import { TWOFA_STATUS } from './../../../models/User';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../abstraction/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { SecondFactorDialogComponent } from '../second-factor-dialog/second-factor-dialog.component';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { ChangePasswordComponent } from '../../profile/change-password/change-password.component';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
})
export class SecurityComponent implements OnInit {
  @ViewChild('twoFAToggle') twoFAToggle: MatSlideToggle;
  twoFAActivated: boolean;
  quickContentOpened = false;

  constructor(
    public auth: AuthService,
    public dialog: MatDialog,
    public authService: AuthService,
    private readonly sso: ScrollStrategyOptions,
    public matDialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.twoFAActivated = this.auth.loggedUser.security.twoFA.status === TWOFA_STATUS.ACTIVE;
  }

  // 2FA
  open2FADialog(type: string) {
    this.dialog
      .open(SecondFactorDialogComponent, {
        backdropClass: 'dialog-primary-backdrop',
        panelClass: 'activation',
        width: '40%',
        maxWidth: '748px',
        minWidth: 'fit-content',
        data: {
          type,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (!res) {
          this.twoFAActivated = !this.twoFAActivated;
        }
      });
  }

  openChangePasswordComponent(type: string) {
    this.quickContentOpened = false;
    if (this.authService.checkOnboardingStatus()) {
      const params = {
        backdropClass: 'dialog-primary-backdrop',
        panelClass: 'deposit',
        width: '40%',
        maxWidth: '748px',
        minWidth: 'fit-content',
        scrollStrategy: this.sso.reposition({
          autoClose: false,
          scrollThrottle: 300,
        }),
        data: undefined,
      };
      if (type !== 'all' && type !== '') {
        params.data = type;
      }

      const dialogRef = this.matDialog.open(ChangePasswordComponent, params);

      dialogRef.afterClosed().subscribe((data) => {});
    }
  }

  toggle2FA() {
    if (this.auth.loggedUser.security.twoFA.status !== 2) {
      this.twoFAActivated = true;
      this.open2FADialog('activate');
    } else {
      this.twoFAActivated = false;
      this.open2FADialog('deactivate');
    }
  }
}
